import { useRef, ReactElement } from 'react'

import classNames from 'classnames'
import Lottie, { LottieRefCurrentProps } from 'lottie-react'

import { useRegistToSequentialList } from '@web/libs/sequential'

import StampLottie from '../../modal/lottie/Place_ReviewStamp1.json'
import CheckLottie from '../../modal/lottie/Place_ReviewStamp2.json'
import styles from '../MissionCard/Content/ProgressStamp/ProgressStamp.module.scss'

interface Props {
  order?: number
  children?: ReactElement
}
const CheckAnimationStamp = ({ order = 1, children, ...props }: Props) => {
  const stampRef = useRef<LottieRefCurrentProps>(null)
  const checkRef = useRef<LottieRefCurrentProps>(null)

  useRegistToSequentialList({
    order,
    onExecute: () => {
      stampRef.current?.play()
    },
    type: 'afterPrev',
    delaySeconds: 0,
    durationSeconds: 1.3,
    id: `stamp-${order}`,
  })

  useRegistToSequentialList({
    order,
    onExecute: () => checkRef.current?.play(),
    type: 'withPrev',
    delaySeconds: 0.8,
    durationSeconds: 0.6,
    id: `check-${order}`,
  })

  return (
    <li className={classNames(styles.list_item)} {...props}>
      <div className={styles.list_item_inner}>
        <div className={classNames(styles.circle_area)}>
          <Lottie
            lottieRef={checkRef}
            autoplay={false}
            className={styles.lottie_single}
            style={{
              width: '200%',
              height: '200%',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1,
            }}
            loop={false}
            animationData={CheckLottie}
          />
          <Lottie
            lottieRef={stampRef}
            autoplay={false}
            style={{
              width: '250%',
              position: 'absolute',
              bottom: '-5px',
              left: '-6px',
              zIndex: 1,
            }}
            loop={false}
            animationData={StampLottie}
          />
          {children}
        </div>
      </div>
    </li>
  )
}

export default CheckAnimationStamp
